<template>
    <TopNavigation title="" hideSecondNavbar="true" />

    <div style="margin-top: 60px">
        <div class="featureContainer">
            <div class="row">
                <div class="col-12 text-center secTitle">Features</div>

                <div class="col-12 mb-4">
                    <div class="row mb-2">

                        <div class="col-md-6 col-lg-4 p-3 d-grid">
                            <div class="feaBox border shadow-sm">
                                <table class="table table-borderless table-sm">
                                    <tr>
                                        <td class="align-middle" width="25%"><i class="fa-solid fa-signature fa-3x"></i></td>
                                        <td class="feaTitle">Digital Signature</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="pt-2 text-grey">
                                            Eliminate unauthorized duplication and ensure legal compliance with secure digital signatures.
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4 p-3 d-grid">
                            <div class="feaBox border shadow-sm">
                                <table class="table table-borderless table-sm">
                                    <tr>
                                        <td class="align-middle" width="25%"><i class="fa-solid fa-fingerprint fa-3x"></i></td>
                                        <td class="feaTitle">Data Integrity - Fingerprint</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="pt-2 text-grey">
                                            Every document is assigned a unique digital fingerprint, guaranteeing that the content remains untampered and original from the moment of signing.
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4 p-3 d-grid">
                            <div class="feaBox border shadow-sm">
                                <table class="table table-borderless table-sm">
                                    <tr>
                                        <td class="align-middle" width="25%"><i class="fa-solid fa-shield-check fa-3x"></i></td>
                                        <td class="feaTitle">Instant Public Verification</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="pt-2 text-grey">
                                            Verify document authenticity in seconds using our free online tool that flags modifications instantly for secure validation without needing external apps.
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4 p-3 d-grid">
                            <div class="feaBox border shadow-sm">
                                <table class="table table-borderless table-sm">
                                    <tr>
                                        <td class="align-middle" width="25%"><i class="fa-solid fa-user-gear fa-3x"></i></td>
                                        <td class="feaTitle">Collaborative Workflows</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="pt-2 text-grey">
                                            Streamline complex signing sequences through integrated collaboration tools, reducing turnaround time and maximizing organizational efficiency.
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4 p-3 d-grid">
                            <div class="feaBox border shadow-sm">
                                <table class="table table-borderless table-sm">
                                    <tr>
                                        <td class="align-middle" width="25%"><i class="fa-solid fa-folder-tree fa-3x"></i></td>
                                        <td class="feaTitle">Dynamic Document Management</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="pt-2 text-grey">
                                            Centralize your document management with real-time tracking and an automated audit trail to oversee the entire lifecycle with confidence.
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4 p-3 d-grid">
                            <div class="feaBox border shadow-sm">
                                <table class="table table-borderless table-sm">
                                    <tr>
                                        <td class="align-middle" width="25%"><i class="fa-solid fa-user-lock fa-3x"></i></td>
                                        <td class="feaTitle">Tiered Access Controls</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="pt-2 text-grey">
                                            Protect confidentiality with tiered permissions, ensuring sensitive documents are accessible only to the right people.
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4 p-3 d-grid">
                            <div class="feaBox border shadow-sm">
                                <table class="table table-borderless table-sm">
                                    <tr>
                                        <td class="align-middle" width="25%"><i class="fa-solid fa-wand-magic-sparkles fa-3x"></i></td>
                                        <td class="feaTitle">Streamlined Execution</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="pt-2 text-grey">
                                            Simple end-to-end document signing flow — upload, invite, sign, and seal documents in just a few clicks, anywhere in the world.
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4 p-3 d-grid">
                            <div class="feaBox border shadow-sm">
                                <table class="table table-borderless table-sm">
                                    <tr>
                                        <td class="align-middle" width="25%"><i class="fa-solid fa-clock-rotate-left fa-3x"></i></td>
                                        <td class="feaTitle">Real-Time Lifecycle Transparency</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="pt-2 text-grey">
                                            Track document progress with real-time updates for complete control and transparency from start to finish.
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4 p-3 d-grid">
                            <div class="feaBox border shadow-sm">
                                <table class="table table-borderless table-sm">
                                    <tr>
                                        <td class="align-middle" width="25%"><i class="fa-solid fa-display fa-3x"></i></td>
                                        <td class="feaTitle">Cross-Platform Responsiveness</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="pt-2 text-grey">
                                            Experience seamless functionality and a consistent workspace across all devices, including desktops, tablets, and mobile phones.
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="greyContainer"> -->
        <div>
            <div class="featureContainer">
                <div class="row">
                    <div class="col-12 text-center secTitle">Comparison</div>

                    <div class="col-12 mb-4">
                        <div class="px-2">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr class="bg-secondary text-white">
                                            <th width="30%"></th>
                                            <th width="35%">SignOn</th>
                                            <th width="35%">Brand 'A'</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="fw-bold">Tamper and Alter Detection</td>
                                            <td>Instant online verification flags any tampering immediately, ensuring total authenticity without extra software.</td>
                                            <td>Requires specific software or manual checks; modifications may go unnoticed by non-technical users.</td>
                                        </tr>

                                        <tr>
                                            <td class="fw-bold">Verification Tool</td>
                                            <td>Free, user-friendly tool for immediate tamper detection.</td>
                                            <td>Passive indicators that require expert knowledge to interpret.</td>
                                        </tr>

                                        <tr>
                                            <td class="fw-bold">Simplicity</td>
                                            <td>A streamlined "Sign and Go" platform designed for ease of use without needing PDF expertise.</td>
                                            <td>A complex creation tool built for heavy editing and file manipulation, which can be overkill for simple signing.</td>
                                        </tr>

                                        <tr>
                                            <td class="fw-bold">Pricing</td>
                                            <td>Flexible, cost-effective plans for growing teams.</td>
                                            <td>Premium, high-cost enterprise subscriptions.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="footer" style="bottom: 0px">
            <Footer />
        </div>
    </div>
</template>

<script>
import { ref, inject, onMounted } from 'vue'
import TopNavigation from '@/components/TopNavigation.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'CompanyInfo',
    components: { TopNavigation, Footer },
    setup () {

        const navigateToHome = () => {
            window.location.href = window.location.origin + '/#home'
        }

        onMounted(() => {

        })

        return { navigateToHome }
    }
}
</script>

<style>
.featureContainer {
    max-width: 1000px;
    margin: 60px auto 60px auto;
    border-radius: 10px;
} 

.lblTitle {
    font-size: 24px;
    font-weight: 600;
    line-height: 1.43;
    color: var(--section-title);
    font-family: "Inter-Medium", sans-serif;
}

.feaBox {
    padding: 1.5rem 1.2rem;
    border-radius: 15px;
    min-height: 225px;
}

.feaTitle {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.43;
    color: #6E777E;
    font-family: "Inter-Medium", sans-serif;
    text-align: left;
}

.greyContainer {
  margin-top: 30px;
  padding-top: 50px;
  padding-bottom: 50px;
  background-color: var(--navbar-light);
}
</style>